<template>
    <v-select
        v-model="selectedElements"
        :items="availableFields"
        multiple
        :label="label"
        :hint="hint"
        persistent-hint
        :item-text="itemText"
        @change="update"
    >
        <template v-slot:prepend-item>
            <v-list-item
                ripple
                @click="toggle"
            >
                <v-list-item-action>
                    <v-icon :color="selectedElements.length > 0 ? 'blue accent-1' : ''">
                        {{ icon }}
                    </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('instance.query_fields.select_query.select_all')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>
        <slot></slot>
    </v-select>
</template>

<script>

export default {

    components: {

    },

    props: {
        parentSelectedElements: {
            type: Array,
            required: true,
        },
        availableFields: {
            type: Array,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        hint: {
            type: String,
            required: true,
        },
        itemText: {
            type: String,
            required: false,
            default: 'text',
        }
    },

    data (){
        return {
            selectedElements: [],
        };
    },

    computed: {
        icon() {
            if (this.allElementsSelected || this.someElementsSelected) return 'indeterminate_check_box';
            return 'check_box_outline_blank';
        },
        allElementsSelected() {
            return this.selectedElements.length === this.availableFields.length;
        },
        someElementsSelected() {
            return this.selectedElements.length > 0 && !this.allElementsSelected;
        },
    },

    mounted (){
        this.selectedElements = this.parentSelectedElements;
    },

    methods: {
        toggle() {
            let availableFields = this.availableFields.filter((item) => item.hasOwnProperty('value') || typeof item === 'string').slice();
            this.$nextTick(() => {
                if (this.allElementsSelected || this.someElementsSelected) {
                    this.selectedElements = []
                } else {
                    this.selectedElements = availableFields;
                }
                this.update(this.selectedElements);
            });
        },
        update (values){
            this.$emit('on-new-elements-selected', values);
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Instance/QueryFields/select-query.vue